/**
 * Created by Ning Jiang on 4/20/2020.
 */

import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {UserAgent} from "@nolimitcity/slot-game/bin/core/useragent/UserAgent";
import {IdleAnimationController} from "@nolimitcity/slot-game/bin/game/idleanimation/IdleAnimationController";
import {DeadwoodSoundConfig} from "../DeadwoodSoundConfig";
import {TweenLite} from "gsap";

export class BackgroundIdleAnimation extends IdleAnimationController {

    private _hasInit:boolean;
    private _sprite:PIXI.Sprite;
    private _spine:PIXI.spine.Spine;

    constructor() {
        super({
            startTime : 3,
            minInterval : 15,
            maxInterval : 40
        })
    }

    protected onGameDataParsed(data:ParsedGameData):void {
    }

    protected hasWin():boolean {
        return !UserAgent.isMobile;
    }

    public init(backgroundSprite:PIXI.Sprite):void {
        this._sprite = backgroundSprite;

        this._spine = new PIXI.spine.Spine(GameResources.getSpineAsset("metalPanel"));
        this._spine.autoUpdate = true;
        this._sprite.addChild(this._spine);
        // this._spine.state.setAnimation(0, `animation`, true);

        this._hasInit = true;
    }

    protected playIdleAnimation():void {
        if(!this._hasInit ||  StageManager.orientation !== Orientation.PORTRAIT) {
            return;
        }

        SlotGame.sound.playEffect(DeadwoodSoundConfig.instance.SIGN_IDLE);
        TweenLite.to(this, 0.5, {onComplete: () => {
                this._spine.state.clearTrack(0);
                this._spine.skeleton.setToSetupPose();
                this._spine.state.setAnimation(0, `animation`, false);
            }});
    }
}